import {
  FETCH_STONE_CUT_REQUEST,
  FETCH_STONE_CUT_SUCCESS,
  FETCH_STONE_CUT_FAILURE,
  ADD_STONE_CUT_REQUEST,
  ADD_STONE_CUT_SUCCESS,
  ADD_STONE_CUT_FAILURE,
  UPDATE_STONE_CUT_REQUEST,
  UPDATE_STONE_CUT_SUCCESS,
  UPDATE_STONE_CUT_FAILURE,
  DELETE_STONE_CUT_REQUEST,
  DELETE_STONE_CUT_SUCCESS,
  DELETE_STONE_CUT_FAILURE,
  STONE_CUT_FORM_ERROR,
  STONE_CUT_FORM_SUCCESS,
  SET_STONE_CUT_EDIT,
  CLEAR_STONE_CUT_EDIT,
} from '../../../../types/masters/stoneAttribute/stoneCut/stoneCutTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingStoneCut: null,
};

const stoneCutReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STONE_CUT_REQUEST:
    case ADD_STONE_CUT_REQUEST:
    case UPDATE_STONE_CUT_REQUEST:
    case DELETE_STONE_CUT_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_STONE_CUT_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_STONE_CUT_SUCCESS:
    case UPDATE_STONE_CUT_SUCCESS:
    case DELETE_STONE_CUT_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_STONE_CUT_FAILURE:
    case ADD_STONE_CUT_FAILURE:
    case UPDATE_STONE_CUT_FAILURE:
    case DELETE_STONE_CUT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case STONE_CUT_FORM_ERROR:
      return { ...state, loading: false, formError: action.payload };
    case STONE_CUT_FORM_SUCCESS:
      return { ...state, loading: false, formSuccess: action.payload };
    case SET_STONE_CUT_EDIT:
      return { ...state, editingStoneCut: action.payload };
    case CLEAR_STONE_CUT_EDIT:
      return { ...state, editingStoneCut: null };
    default:
      return state;
  }
};

export default stoneCutReducer; 